export const ROLE_MATERIALS = [
  {
    id: 'backend-developer',
    title: 'Backend Developer',
    category: 'Technology',
    summary: 'Build and maintain server-side applications, APIs, and data services.',
    skills: ['APIs', 'Databases', 'Authentication', 'Testing'],
    courses: [
      { id: 'bd-course-1', title: 'Python Programming', provider: 'Edutory', level: 'Beginner', duration: '10-14 weeks', url: 'https://www.edutory.net/Programming' },
      { id: 'bd-course-2', title: 'Node.js Backend Development', provider: 'Edutory', level: 'Intermediate', duration: '12-16 weeks', url: 'https://www.edutory.net/Programming' },
      { id: 'bd-course-3', title: 'C Programming Fundamentals', provider: 'Edutory', level: 'Beginner', duration: '8-12 weeks', url: 'https://www.edutory.net/Programming' },
      { id: 'bd-course-4', title: 'SQL for Data Science', provider: 'Edutory', level: 'Beginner', duration: '2 months', url: 'https://www.edutory.net/Data%20Science' },
    ],
    certifications: [
      { id: 'bd-cert-1', title: 'Backend Developer Certificate', provider: 'Edutory', level: 'Intermediate', url: 'https://www.edutory.net/Programming' },
      { id: 'bd-cert-2', title: 'Node.js Developer Certificate', provider: 'Edutory', level: 'Advanced', url: 'https://www.edutory.net/Programming' },
    ],
    references: [
      { id: 'bd-ref-1', title: 'REST API Guidelines', provider: 'Engineering Playbook', url: '#' },
      { id: 'bd-ref-2', title: 'Database Indexing Cheatsheet', provider: 'Edutory Reference', url: '#' },
    ],
  },
  {
    id: 'frontend-developer',
    title: 'Frontend Developer',
    category: 'Technology',
    summary: 'Create responsive, accessible, and performant user interfaces.',
    skills: ['HTML/CSS', 'JavaScript', 'React', 'Accessibility'],
    courses: [
      { id: 'fe-course-1', title: 'Web Development Fundamentals', provider: 'Edutory', level: 'Beginner', duration: '8-12 weeks', url: 'https://www.edutory.net/Programming' },
      { id: 'fe-course-2', title: 'Modern CSS & Responsive Design', provider: 'Edutory', level: 'Beginner', duration: '6-10 weeks', url: 'https://www.edutory.net/Programming' },
      { id: 'fe-course-3', title: 'JavaScript Programming Essentials', provider: 'Edutory', level: 'Intermediate', duration: '10-14 weeks', url: 'https://www.edutory.net/Programming' },
      { id: 'fe-course-4', title: 'React.js Development', provider: 'Edutory', level: 'Intermediate', duration: '12-16 weeks', url: 'https://www.edutory.net/Programming' },
      { id: 'fe-course-5', title: 'Angular Framework Development', provider: 'Edutory', level: 'Intermediate', duration: '12-16 weeks', url: 'https://www.edutory.net/Programming' },
    ],
    certifications: [
      { id: 'fe-cert-1', title: 'Frontend Development Certificate', provider: 'Edutory', level: 'Intermediate', url: 'https://www.edutory.net/Programming' },
      { id: 'fe-cert-2', title: 'React Developer Certificate', provider: 'Edutory', level: 'Advanced', url: 'https://www.edutory.net/Programming' },
      { id: 'fe-cert-3', title: 'Angular Developer Certificate', provider: 'Edutory', level: 'Advanced', url: 'https://www.edutory.net/Programming' },
    ],
    references: [
      { id: 'fe-ref-1', title: 'Accessibility Checklist', provider: 'Edutory Reference', url: '#' },
      { id: 'fe-ref-2', title: 'Design Systems Guide', provider: 'UI Engineering', url: '#' },
    ],
  },
  {
    id: 'devops-engineer',
    title: 'DevOps Engineer',
    category: 'Technology',
    summary: 'Automate deployments, infrastructure, and reliability workflows.',
    skills: ['CI/CD', 'Cloud', 'Observability', 'Infrastructure as Code'],
    courses: [
      { id: 'de-course-1', title: 'DevOps Foundations', provider: 'Edutory', level: 'Intermediate', duration: '10-14 weeks', url: 'https://www.edutory.net/Networking' },
      { id: 'de-course-2', title: 'Network Security & Administration', provider: 'Edutory', level: 'Intermediate', duration: '12-16 weeks', url: 'https://www.edutory.net/Networking' },
      { id: 'de-course-3', title: 'Linux System Administration', provider: 'Edutory', level: 'Intermediate', duration: '8-12 weeks', url: 'https://www.edutory.net/Programming' },
      { id: 'de-course-4', title: 'IT Essentials – Bridge to Version 8.0', provider: 'Edutory', level: 'Beginner', duration: '1 week', url: 'https://www.edutory.net/courses' },
    ],
    certifications: [
      { id: 'de-cert-1', title: 'DevOps Engineer Certificate', provider: 'Edutory', level: 'Advanced', url: 'https://www.edutory.net/Networking' },
      { id: 'de-cert-2', title: 'Network Professional Certificate', provider: 'Edutory', level: 'Advanced', url: 'https://www.edutory.net/Networking' },
      { id: 'de-cert-3', title: 'Linux Professional Certificate', provider: 'Edutory', level: 'Intermediate', url: 'https://www.edutory.net/Programming' },
    ],
    references: [
      { id: 'de-ref-1', title: 'Incident Response Runbook', provider: 'Edutory Reference', url: '#' },
      { id: 'de-ref-2', title: 'Kubernetes Essentials', provider: 'Ops Field Notes', url: '#' },
    ],
  },
  {
    id: 'data-scientist',
    title: 'Data Scientist',
    category: 'Analytics',
    summary: 'Analyze data, build models, and communicate insights.',
    skills: ['Python', 'Statistics', 'ML', 'Data Visualization'],
    courses: [
      { id: 'ds-course-1', title: 'Data Analysis Using Python', provider: 'Edutory', level: 'Beginner', duration: '9 weeks', url: 'https://www.edutory.net/Data%20Science' },
      { id: 'ds-course-2', title: 'Data Science Essentials with Python', provider: 'Edutory', level: 'Intermediate', duration: '6 weeks', url: 'https://www.edutory.net/Data%20Science' },
      { id: 'ds-course-3', title: 'SQL for Data Science', provider: 'Edutory', level: 'Beginner', duration: '2 months', url: 'https://www.edutory.net/Data%20Science' },
      { id: 'ds-course-4', title: 'AI for Everyone', provider: 'Edutory', level: 'Beginner', duration: '7 weeks', url: 'https://www.edutory.net/Data%20Science' },
      { id: 'ds-course-5', title: 'Machine Learning Mastery', provider: 'Edutory', level: 'Advanced', duration: '12-16 weeks', url: 'https://www.edutory.net/Data%20Science' },
    ],
    certifications: [
      { id: 'ds-cert-1', title: 'Data Science Professional Certificate', provider: 'Edutory', level: 'Advanced', url: 'https://www.edutory.net/Data%20Science' },
      { id: 'ds-cert-2', title: 'Machine Learning Specialist Certificate', provider: 'Edutory', level: 'Advanced', url: 'https://www.edutory.net/Data%20Science' },
    ],
    references: [
      { id: 'ds-ref-1', title: 'Model Evaluation Guide', provider: 'Edutory Reference', url: '#' },
      { id: 'ds-ref-2', title: 'Data Storytelling Playbook', provider: 'Analytics Guild', url: '#' },
    ],
  },
  {
    id: 'product-manager',
    title: 'Product Manager',
    category: 'Business',
    summary: 'Define product strategy, align teams, and deliver outcomes.',
    skills: ['Roadmapping', 'User Research', 'Analytics', 'Stakeholder Management'],
    courses: [
      { id: 'pm-course-1', title: 'Product Management Foundations', provider: 'Edutory', level: 'Beginner', duration: '8-10 weeks', url: 'https://www.edutory.net/Management' },
      { id: 'pm-course-2', title: 'Data Analysis Using Python', provider: 'Edutory', level: 'Beginner', duration: '9 weeks', url: 'https://www.edutory.net/Data%20Science' },
      { id: 'pm-course-3', title: 'SQL for Data Science', provider: 'Edutory', level: 'Beginner', duration: '2 months', url: 'https://www.edutory.net/Data%20Science' },
    ],
    certifications: [
      { id: 'pm-cert-1', title: 'Product Management Certificate', provider: 'Edutory', level: 'Intermediate', url: 'https://www.edutory.net/Management' },
      { id: 'pm-cert-2', title: 'Data Science Professional Certificate', provider: 'Edutory', level: 'Advanced', url: 'https://www.edutory.net/Data%20Science' },
    ],
    references: [
      { id: 'pm-ref-1', title: 'PRD Template', provider: 'Edutory Reference', url: '#' },
      { id: 'pm-ref-2', title: 'Customer Interview Guide', provider: 'Product Ops', url: '#' },
    ],
  },
];
